import { useEffect } from "react";
import ReactGA from "react-ga4";

export default function useAnalyticsPageView() {
    useEffect(()=>{
        /*let path = window.location.pathname + window.location.search;
        if (path === '/my-app') {
            path = path + '/';
        }
        ReactGA.pageview(path);*/
        ReactGA.send("pageview");
    }, []);
}
